import type { ReactNode } from 'react';
import { useAuthStore } from '@/stores/auth.store';
import type { UserRole } from '@/models/auth';

interface AuthGuardProps {
  children: ReactNode;
  requiredRole?: UserRole;
  fallback?: ReactNode;
}

export function AuthGuard({ children, requiredRole, fallback }: AuthGuardProps) {
  const { userInfo, loading } = useAuthStore();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-text-secondary">Loading...</div>
      </div>
    );
  }

  if (!userInfo) {
    return fallback ? <>{fallback}</> : null;
  }

  if (requiredRole && userInfo.role !== requiredRole && userInfo.role !== 'admin') {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-red-600">Access denied</div>
      </div>
    );
  }

  return <>{children}</>;
}
